export const tracks = [
  {
    id: "frontend",
    name: "Frontend & UI/UX",
    icon: "Monitor",
    color: "blue",
    technologies: [
      "React",
      "Flutter",
      "TypeScript",
      "Figma",
      "Tailwind CSS",
      "Dart",
      "HTML5",
      "CSS3",
      "Git",
      "Firebase",
    ],
    milestones: [
      {
        number: "01",
        weekLabel: "WEEK 1-2",
        title: "FRONTEND FOUNDATIONS & UI",
        icon: "LayoutTemplate",
        anim: "float",
        topics: [
          "HTML5 & CSS3 deep dive",
          "Responsive design principles",
          "UI/UX fundamentals & Figma",
          "JavaScript ES6+ essentials",
        ],
      },
      {
        number: "02",
        weekLabel: "WEEK 3-5",
        title: "REACT FUNDAMENTALS",
        icon: "Component",
        anim: "pulse",
        topics: [
          "Component architecture",
          "State management & hooks",
          "React Router & navigation",
          "API integration & data fetching",
        ],
      },
      {
        number: "03",
        weekLabel: "WEEK 6-8",
        title: "FLUTTER FUNDAMENTALS",
        icon: "Smartphone",
        anim: "bounce",
        topics: [
          "Dart programming basics",
          "Flutter widgets & layouts",
          "Cross-platform mobile UI",
          "State management with Provider",
        ],
      },
      {
        number: "04",
        weekLabel: "WEEK 9-10",
        title: "TESTING & DEBUGGING",
        icon: "Bug",
        anim: "shake",
        topics: [
          "Unit & integration testing",
          "Debugging tools & techniques",
          "Performance optimization",
          "Code quality & linting",
        ],
      },
      {
        number: "05",
        weekLabel: "WEEK 11-12",
        title: "DEPLOYMENT & TEAM PROJECT",
        icon: "Rocket",
        anim: "spin",
        topics: [
          "CI/CD pipelines",
          "Cloud deployment",
          "Team collaboration project",
          "Portfolio & presentation",
        ],
      },
    ],
  },

  {
    id: "backend",
    name: "Backend + Machine Learning",
    icon: "Server",
    color: "green",
    technologies: [
      "Python",
      "FastAPI",
      "PostgreSQL",
      "TensorFlow",
      "scikit-learn",
      "Docker",
      "Redis",
      "MongoDB",
      "Git",
      "AWS",
    ],
    milestones: [
      {
        number: "01",
        weekLabel: "WEEK 1-2",
        title: "BACKEND FASTAPI & DATABASE",
        icon: "DatabaseZap",
        anim: "pulse",
        topics: [
          "Python advanced patterns",
          "FastAPI REST endpoints",
          "PostgreSQL & SQLAlchemy",
          "Authentication & security",
        ],
      },
      {
        number: "02",
        weekLabel: "WEEK 3-5",
        title: "ML INTEGRATION WITH BACKEND",
        icon: "Network",
        anim: "float",
        topics: [
          "ML model serving via API",
          "Data pipeline architecture",
          "Real-time predictions",
          "Model versioning & management",
        ],
      },
      {
        number: "03",
        weekLabel: "WEEK 6-8",
        title: "ML FOUNDATIONS & MODEL BUILDING",
        icon: "BrainCircuit",
        anim: "bounce",
        topics: [
          "Supervised & unsupervised learning",
          "Feature engineering",
          "Model training & evaluation",
          "scikit-learn workflows",
        ],
      },
      {
        number: "04",
        weekLabel: "WEEK 9-10",
        title: "DEEP LEARNING & MLOPS",
        icon: "Cpu",
        anim: "spin",
        topics: [
          "Neural network fundamentals",
          "TensorFlow & Keras",
          "MLOps basics & monitoring",
          "Model optimization",
        ],
      },
      {
        number: "05",
        weekLabel: "WEEK 11-12",
        title: "DEPLOYMENT & TEAM PROJECT",
        icon: "CloudCog",
        anim: "float",
        topics: [
          "Docker containerization",
          "Cloud deployment (AWS)",
          "End-to-end ML project",
          "Portfolio & presentation",
        ],
      },
    ],
  },

  {
    id: "vaccine-vault",
    name: "Vaccine Vault (App Validation Project)",
    icon: "Smartphone",
    color: "blue",
    technologies: [
      "Health-tech project context",
      "Communication",
      "App usability concepts",
      "Project documentation",
      "Feedback analysis",
      "User-centered design",
      "Digital health workflows",
      "Research Ethics"
    ],
    milestones: [
      {
        number: "01",
        weekLabel: "WEEK 1-2",
        title: "PROJECT CONTEXT & ETHICS",
        icon: "LayoutTemplate",
        anim: "float",
        topics: [
          "Explore the project context and health-related goals",
          "Review available app and project documentation",
          "Explore communication principles relevant to the project",
          "Review research ethics and privacy concepts"
        ]
      },
      {
        number: "02",
        weekLabel: "WEEK 3-5",
        title: "APP WORKFLOWS & LEARNING",
        icon: "Users",
        anim: "pulse",
        topics: [
          "Explore app workflows through available learning materials",
          "Review onboarding concepts relevant to the project",
          "Map user journeys from available documentation",
          "Identify questions for further project research"
        ]
      },
      {
        number: "03",
        weekLabel: "WEEK 6-8",
        title: "USABILITY & FEEDBACK CONCEPTS",
        icon: "CheckCircle2",
        anim: "bounce",
        topics: [
          "Explore usability concepts through guided learning activities",
          "Identify usability questions from project materials",
          "Review feedback documented in available project resources",
          "Summarize findings from reviewed materials"
        ]
      },
      {
        number: "04",
        weekLabel: "WEEK 9-10",
        title: "OBSERVATION CONSOLIDATION",
        icon: "Briefcase",
        anim: "shake",
        topics: [
          "Organize available project materials",
          "Categorize themes in reviewed feedback",
          "Synthesize research notes",
          "Draft a project learning summary"
        ]
      },
      {
        number: "05",
        weekLabel: "WEEK 11-12",
        title: "FINAL VALIDATION REPORT",
        icon: "FileSearch",
        anim: "spin",
        topics: [
          "Compile a summary of project learnings",
          "Review usability and feedback-analysis concepts",
          "Explore relevant case studies where available and authorised",
          "Complete project documentation"
        ]
      }
    ]
  },

  {
    id: "dementia-detection",
    name: "Dementia Detection Project",
    icon: "Brain",
    color: "green",
    technologies: [
      "Clinical research concepts",
      "ICH-GCP Guidelines",
      "Research ethics",
      "Project documentation",
      "Privacy concepts",
      "Research Ethics",
      "Data interpretation",
      "Academic resources"
    ],
    milestones: [
      {
        number: "01",
        weekLabel: "WEEK 1-2",
        title: "ICH-GCP & RESEARCH ETHICS",
        icon: "BookOpenCheck",
        anim: "float",
        topics: [
          "Explore ICH-GCP principles through available learning resources",
          "Review research ethics and privacy concepts",
          "Study relevant project documentation where available",
          "Learn about permissions relevant to clinical research settings"
        ]
      },
      {
        number: "02",
        weekLabel: "WEEK 3-5",
        title: "RESEARCH CONCEPTS & LEARNING",
        icon: "Briefcase",
        anim: "pulse",
        topics: [
          "Explore dementia detection research concepts through academic resources",
          "Review project documentation where available",
          "Learn about screening concepts at a high level",
          "Consider research methods and their limitations"
        ]
      },
      {
        number: "03",
        weekLabel: "WEEK 6-8",
        title: "SCREENING CONCEPTS & PROJECT REVIEW",
        icon: "Users",
        anim: "bounce",
        topics: [
          "Study screening approaches through available academic materials",
          "Review evaluation concepts and potential limitations",
          "Consider ethical data handling and participant privacy",
          "Summarize learning from approved project materials"
        ]
      },
      {
        number: "04",
        weekLabel: "WEEK 9-10",
        title: "RESEARCH DOCUMENTATION",
        icon: "CheckCircle2",
        anim: "shake",
        topics: [
          "Organize project notes clearly",
          "Distinguish documented information from interpretation",
          "Review privacy and research ethics considerations",
          "Refine a research summary using feedback where available"
        ]
      },
      {
        number: "05",
        weekLabel: "WEEK 11-12",
        title: "RESEARCH DOCUMENTATION",
        icon: "Microscope",
        anim: "spin",
        topics: [
          "Compile a summary of research concepts and project learnings",
          "Draft a research-oriented project report",
          "Prepare a presentation of key learning points",
          "Review project scope and learning outcomes"
        ]
      }
    ]
  },

  {
    id: "elderly-fall",
    name: "Elderly Fall Detection (Multimodal)",
    icon: "Activity",
    color: "blue",
    technologies: [
      "Fall-prevention concepts",
      "ICH-GCP Guidelines",
      "Research ethics",
      "Project documentation",
      "Environmental risk concepts",
      "Mobility data concepts",
      "Academic resources",
      "Research methods"
    ],
    milestones: [
      {
        number: "01",
        weekLabel: "WEEK 1-2",
        title: "RESEARCH PREPARATION & ETHICS",
        icon: "Layers",
        anim: "float",
        topics: [
          "Explore fall-risk concepts through available learning resources",
          "Review ICH-GCP principles and research ethics",
          "Study project context and available documentation",
          "Consider ethical research principles for vulnerable groups"
        ]
      },
      {
        number: "02",
        weekLabel: "WEEK 3-5",
        title: "PARTICIPANT-CENTERED RESEARCH CONCEPTS",
        icon: "Users",
        anim: "pulse",
        topics: [
          "Explore communication considerations for older adults",
          "Review assessment concepts through academic resources",
          "Consider inclusive and respectful research practices",
          "Learn about privacy and consent principles"
        ]
      },
      {
        number: "03",
        weekLabel: "WEEK 6-8",
        title: "MULTIMODAL OBSERVATION CONCEPTS",
        icon: "Activity",
        anim: "bounce",
        topics: [
          "Study environmental fall-risk factors using available resources",
          "Explore mobility data concepts",
          "Review gait and balance assessment concepts at a high level",
          "Learn approaches to organizing research notes"
        ]
      },
      {
        number: "04",
        weekLabel: "WEEK 9-10",
        title: "RESEARCH NOTES & ANALYSIS",
        icon: "Briefcase",
        anim: "shake",
        topics: [
          "Organize available project materials",
          "Structure research notes clearly",
          "Review research ethics and privacy principles",
          "Summarize environmental risk themes from reviewed resources"
        ]
      },
      {
        number: "05",
        weekLabel: "WEEK 11-12",
        title: "FINAL REPORT & INSIGHTS",
        icon: "FileSearch",
        anim: "spin",
        topics: [
          "Compile a summary of fall-risk concepts and project learnings",
          "Draft a research-oriented report based on available materials",
          "Prepare a presentation of key learning points",
          "Complete project documentation"
        ]
      }
    ]
  }
];
